import { render } from "./DocsViews.vue?vue&type=template&id=3ada07ca&scoped=true"
import script from "./DocsViews.vue?vue&type=script&lang=js"
export * from "./DocsViews.vue?vue&type=script&lang=js"

import "./DocsViews.vue?vue&type=style&index=0&id=3ada07ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada07ca"]])

export default __exports__